import { useEffect } from 'react';
import { useEditMode } from '../context/EditModeContext';

export function useRichTextTarget(isActive, element) {
  const { registerRichTextElement, unregisterRichTextElement } = useEditMode();

  useEffect(() => {
    if (!isActive || !element) return undefined;
    registerRichTextElement(element);
    return () => unregisterRichTextElement(element);
  }, [isActive, element, registerRichTextElement, unregisterRichTextElement]);
}
